__turbopack_context__.v({
  "hint": "xHs1hq_hint",
  "iconBox": "xHs1hq_iconBox",
  "label": "xHs1hq_label",
  "leadingArrow": "xHs1hq_leadingArrow",
  "link": "xHs1hq_link",
  "text": "xHs1hq_text",
});
